import { apiFetch } from './api.js'

const BASE = (import.meta.env.VITE_API_BASE ?? '') + '/wiring'

/** The current wiring plan with the device catalog: { layout, version, updated_at, updated_by, seeded, catalog }. */
export async function fetchWiring() {
  const r = await apiFetch(BASE)
  if (!r.ok) throw new Error(`wiring ${r.status}`)
  return r.json()
}

/**
 * Saves the plan as the next version. Resolves { ok, status, ...body }: 409 when someone
 * saved in between (body carries their version), 400 with `errors` when the plan is invalid.
 */
export async function saveWiring({ layout, baseVersion, summary }) {
  const r = await apiFetch(BASE, {
    method: 'PUT', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ layout, baseVersion, summary }),
  })
  const body = await r.json().catch(() => ({}))
  return { ok: r.ok, status: r.status, ...body }
}

/** The last saves, newest first. */
export async function fetchWiringVersions() {
  const r = await apiFetch(`${BASE}/versions`)
  if (!r.ok) throw new Error(`wiring versions ${r.status}`)
  return r.json()
}

/** One saved plan (0 = the starting plan). */
export async function fetchWiringVersion(version) {
  const r = await apiFetch(`${BASE}/versions/${encodeURIComponent(version)}`)
  if (!r.ok) throw new Error(`wiring version ${r.status}`)
  return r.json()
}

/** The plan as an indented text tree, with live watts. */
export async function fetchWiringText() {
  const r = await apiFetch(`${BASE}/text?live=1`)
  if (!r.ok) throw new Error(`wiring text ${r.status}`)
  return r.text()
}
